import React from 'react';
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import CertificationDetail from '../../Components/Certifications/CertificationDetail/CertificationDetail';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';

function CertificationDetailPage() {
  return (
    <div className="BallotsPage">
      <div className="ballotsPageContainer">
        <div className="headerContain">
          <Header />
        </div>
        <div className="ballotsPageContainer2">
          <div className="sidebarContain">
            <Sidebar />
          </div>
          <div className="middleContainer">
            <CertificationDetail />
          </div>
          <div className="dashboardRightSectionContain">
            <DashboardRightSection />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CertificationDetailPage;
